import React, { Component } from "react";
import ReactExport from "react-export-excel";
import { Button } from "antd";
import { FileExcelOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;
const ExcelCell = ReactExport.ExcelFile.ExcelCell;

// export default class ExportExcel extends Component {
//   render() {
//     const { filename, data, fields, style, showPeriod } = this.props;
//     return (
//       <ExcelFile
//         element={
//           <Button type="primary" icon="file-excel" style={style} size="small">
//             Экспорт
//           </Button>
//         }
//         filename={filename}
//       >
//         <ExcelSheet data={data} name={filename}>
//           {showPeriod && <ExcelColumn label="Период" />}
//           {fields.map((f) => (
//             <ExcelColumn
//               label={f.title}
//               value={f.dataIndex}
//               key={f.dataIndex}
//             />
//           ))}
//         </ExcelSheet>
//       </ExcelFile>
//     );
//   }
// }

export default function (props) {
  const { filename, data, fields, style, showPeriod } = props;
  const { t, i18n } = useTranslation();
  return (
    <ExcelFile
      element={
        <Button
          type="primary"
          icon={<FileExcelOutlined />}
          style={style}
          size="small"
        >
          {t("component.export")}
        </Button>
      }
      filename={filename}
    >
      {showPeriod ? (
        <ExcelSheet data={data} name={filename}>
          <ExcelColumn label={`Период ${showPeriod[0]} - ${showPeriod[1]}`} />
          {fields.map((f) => (
            <ExcelColumn
              label={f.title}
              value={f.dataIndex}
              key={f.dataIndex}
            />
          ))}
        </ExcelSheet>
      ) : (
        <ExcelSheet data={data} name={filename}>
          {fields.map((f) => (
            <ExcelColumn
              label={f.title}
              value={f.dataIndex}
              key={f.dataIndex}
            />
          ))}
        </ExcelSheet>
      )}
    </ExcelFile>
  );
}
